const getWorker = (): Worker => {
    return new Worker(new URL('./overlay.ts', import.meta.url), { type: 'module' });
};

export default getWorker;
